import { useFilters } from '@statsbomb/kitbag-global-football';
import { useTranslation } from 'react-i18next';
import { snakeToCamel } from '@/utils/queries';

export const useMetricName = () => {
  const { t } = useTranslation('metrics');
  const [{ metric: metricKey }] = useFilters('main');
  return metricKey ? t(`${snakeToCamel(metricKey)}.name`, { ns: 'metrics' }) : '';
};
